import MyAccount from 'containers/AccountPage'
import Employees from 'containers/Employees'
import Page404 from 'containers/Page404/Page404'
import { PageEmailConfirmation } from 'containers/PageEmailConfirmation/EmailConfirmation'
import PageForgotPassword from 'containers/PageForgotPassword'
import PageResetPassword from 'containers/PageForgotPassword/PageResetPassword'
import Home from 'containers/PageHome'
import PageLogin from 'containers/PageLogin/PageLogin'
import Rewards from 'containers/PageRewards'
// import Rewards from 'containers/PageRewards'
import { createBrowserRouter, Navigate } from 'react-router-dom'

export const MyRoutes = createBrowserRouter(
  [
    {
      path: '/',
      element: <PageLogin />,
    },
    {
      path: '/employees',
      element: <Employees />,
    },
    {
      path: '/login',
      element: <Navigate to="/" />,
    },
    {
      path: '/forgot-password',
      element: <PageForgotPassword />,
    },
    {
      path: '/form-forgot-password',
      element: <PageResetPassword />,
    },
    {
      path: '/home',
      element: <Home />,
    },
    {
      path: '/my-account',
      element: <MyAccount />,
    },
    {
      path: '*',
      element: <Page404 />,
    },
    {
      path: '/confirm',
      element: <PageEmailConfirmation />,
    },
    {
      path: '/rewards',
      element: <Rewards />,
    },
  ],
  {
    basename: process.env.PUBLIC_URL,
  },
)
